<template>
  <!-- 用户数据 -->
  <div>
    <div class="userData">
      <HeadTitle :url="url"></HeadTitle>
      <div style="margin-top: 50px">
        <div class="topBox">
          <div class="topBoxItem topBoxOne">
            <div class="topBoxContent">
              <div class="num">34</div>
              <div class="text">社区日发帖</div>
            </div>
          </div>
          <div class="topBoxItem">
            <div class="topBoxContent">
              <div class="num">102</div>
              <div class="text">评论数据</div>
            </div>
          </div>
        </div>
        <div class="middleBox">
          <div class="middleTop">用户数据</div>
          <van-tabs v-model="activeTab" @click="clickTab" swipeable>
            <van-tab
              v-for="(item, index) in tabList"
              :key="index"
              :title="item.title"
            >
              <Chart v-if="index === 0" :option="optionUser"></Chart>
              <Chart v-if="index === 1" :option="optionRegister"></Chart>
            </van-tab>
          </van-tabs>
        </div>
        <div class="footBox">
          <div>
            <div class="middleTop">PV&UV数据</div>
            <div>
              <Chart :option="optionShop"></Chart>
            </div>
            <div class="pvBox">商城PV&UV</div>
          </div>
          <div>
            <div>
              <Chart :option="optionCommun"></Chart>
            </div>
            <div class="pvBox">社区PV&UV</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadTitle from "../../components/HeadTitle";
import Chart from "./components/Chart";

export default {
  components: {
    HeadTitle,
    Chart,
  },
  name: "UserData",

  data() {
    return {
      url:"/",
      tabList: [
        {
          id: "0",
          title: "用户数",
        },
        {
          id: "1",
          title: "日注册数",
        },
      ],
      dataList: [
        { name: "用户总数", value: 200 },
        { name: "认证车主", value: 100 },
      ],
      dataList1: [
        { name: "日注册用户", value: 880 },
        { name: "日认证车主", value: 360 },
      ],
      activeTab: 0,
      // 用户数
      optionUser: {
        // "#4871c0"
        color: ["#1989fa", "#a3a3a3"],
        series: [
          {
            type: "pie",
            radius: "45%",
            data: [
              {
                value: 200,
                name: "用户总数",
                label: {
                  show: true,
                  formatter: function (v) {
                    //让series 中的文字进行换行
                    //文字中遇到空格就换行
                    let text = v.name + "\n" + Math.round(v.percent) + "%" + "";
                    // let text =
                    //   Math.round(v.percent) +
                    //   "%" +
                    //   "\n" +
                    //   "" +
                    //   v.name.split(" ").join("\n");
                    return text;
                  },
                  labelLine: {
                    show: true,
                  },
                },
              },
              {
                value: 100,
                name: "认证车主",
                label: {
                  show: true,
                  formatter: function (v) {
                    //让series 中的文字进行换行
                    //文字中遇到空格就换行
                    let text = v.name + "\n" + Math.round(v.percent) + "%" + "";
                    // let text =
                    //   Math.round(v.percent) +
                    //   "%" +
                    //   "\n" +
                    //   "" +
                    //   v.name.split(" ").join("\n");
                    return text;
                  },
                  labelLine: {
                    show: true,
                  },
                },
              },
            ],
          },
        ],
        legend: {
          top: "bottom",
          formatter: (name) => {
            let target;
            for (let i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i]?.name === name) {
                target = "（" + this.dataList[i]?.value + "）";
              }
            }
            let arr = [name, target];
            return arr;
            // return arr.join("\n");
          },
        },
      },
      // 日注册数
      optionRegister: {
        color: ["#1989fa", "#a3a3a3"],
        series: [
          {
            type: "pie",
            radius: "45%",
            data: [
              {
                value: 880,
                name: "日注册用户",
                label: {
                  show: true,
                  formatter: function (v) {
                    //让series 中的文字进行换行
                    //文字中遇到空格就换行
                    let text = v.name + "\n" + Math.round(v.percent) + "%" + "";
                    // let text =
                    //   Math.round(v.percent) +
                    //   "%" +
                    //   "\n" +
                    //   "" +
                    //   v.name.split(" ").join("\n");
                    return text;
                  },
                  labelLine: {
                    show: true,
                  },
                },
              },
              {
                value: 360,
                name: "日认证车主",
                label: {
                  show: true,
                  formatter: function (v) {
                    //让series 中的文字进行换行
                    //文字中遇到空格就换行
                    let text = v.name + "\n" + Math.round(v.percent) + "%" + "";
                    // let text =
                    //   Math.round(v.percent) +
                    //   "%" +
                    //   "\n" +
                    //   "" +
                    //   v.name.split(" ").join("\n");
                    return text;
                  },
                  labelLine: {
                    show: true,
                  },
                },
              },
            ],
          },
        ],
        legend: {
          top: "bottom",
          formatter: (name) => {
            let target;
            for (let i = 0; i < this.dataList1.length; i++) {
              if (this.dataList1[i].name === name) {
                target = "（" + this.dataList1[i]?.value + "）";
              }
            }
            let arr = [name, target];
            return arr;
          },
        },
      },
      // 商城PV&UV
      optionShop: {
        xAxis: {
          type: "category",
          data: ["07-08", "07-09", "07-10", "07-11", "07-12"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [20, 30, 80, 100, 50],
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: "#fb934f", // 柱状图的填充颜色
            },
            barWidth: "45%", // 设置柱状图的宽度
            backgroundStyle: {
              color: "white", // 柱状图未涉及的填充颜色
            },
          },
          {
            data: [20, 30, 80, 100, 50],
            type: "line",
            symbol: "circle", //拐点样式
            symbolSize: 3, //拐点大小
            itemStyle: {
              normal: {
                label: { show: true }, // 折线上显示数值
                lineStyle: {
                  width: 2, //折线宽度
                  color: "#1989fa", // 折线颜色
                },
                color: "#1989fa", //  拐点颜色
                borderColor: "#1989fa", // 拐点边框颜色
                borderWidth: 3, // 拐点边框大小
              },
              emphasis: {
                color: "#000000", // hover拐点颜色定义
              },
            },
          },
        ],
      },
      // 社区PV&UV
      optionCommun: {
        xAxis: {
          type: "category",
          data: ["07-08", "07-09", "07-10", "07-11", "07-12"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: [30, 60, 50, 100, 50],
            type: "bar",
            showBackground: true,
            itemStyle: {
              color: "#fb934f", // 柱状图的填充颜色
            },
            barWidth: "45%", // 设置柱状图的宽度
            backgroundStyle: {
              color: "white", // 柱状图未涉及的填充颜色
            },
          },
          {
            data: [30, 60, 50, 100, 50],
            type: "line",
            symbol: "circle", //拐点样式
            symbolSize: 3, //拐点大小
            itemStyle: {
              normal: {
                label: { show: true }, // 折线上显示数值
                lineStyle: {
                  width: 2, //折线宽度
                  color: "#1989fa", // 折线颜色
                },
                color: "#1989fa", //  拐点颜色
                borderColor: "#1989fa", // 拐点边框颜色
                borderWidth: 3, //拐点边框大小
              },
              emphasis: {
                color: "#000000", //hover拐点颜色定义
              },
            },
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    clickTab(e, title) {
      // e表示激活的下标
      console.log(e, title);
    },
  },
};
</script>
<style scoped lang="less">
.userData {
  margin: 0px 20px;
  .topBox {
    display: flex;
    border-bottom: 10px solid #f2f2f2;
    .topBoxOne {
      border-right: 0.5px solid black;
    }
    .topBoxItem {
      margin: 80px 0px;
      height: 100px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      color: #6b6b6b;
      .topBoxContent {
        .num {
          font-size: 56px;
          font-weight: 600;
        }
        .text {
          font-size: 18px;
        }
      }
    }
  }
  .middleBox {
    height: 780px;
    font-size: 30px;
    font-weight: 600;
    border-bottom: 10px solid #f2f2f2;
    .middleTop {
      height: 100px;
      line-height: 100px;
      border-bottom: 2px solid #f2f2f2;
    }
  }
  .footBox {
    .middleTop {
      height: 80px;
      line-height: 80px;
      border-bottom: 2px solid #f2f2f2;
      font-size: 30px;
      font-weight: 600;
    }
    .pvBox {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
  }
}
</style>